module.exports = __webpack_public_path__ + "media/images/arrows/twisted/orange-right-long-44b90bc305c5f7474b40b1721246ea47.svg";